module.exports = __webpack_public_path__ + "img/gf6sat.cc798685.png";